import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import useClickOutside from "../../../../../../hooks/useClickOutside";
import { PermmisionPostsTypeEnum } from "../../../../../../models/PermmisionPostsTypeEnum";
import { onKeyDown } from "../../../../../../service";
import classes from './AutoComplete.module.css'

const AutoComplete = ({ friendsList, setFriendsList, choosenFriends, setChoosenFriends, beenSharedBefore, changeSpecificFriends }) => {

    const texts = useSelector(state => state.translate.texts);

    const [showParticipants, setShowParticipants] = useState()
    const [inputText, setInputText] = useState("")
    const [permissionMask, setPermissionMask] = useState("RunnerOnly");

    const AutoCompleteRef = useRef();

    function showFriends(text) {
        setInputText(text);
        text !== "" ? setShowParticipants(true) : setShowParticipants(false)
    }

    function chooseFriend(friend) {
        setInputText(friend.name)
        setShowParticipants(false)
    }

    function addFriend() {
        const currentFriend = friendsList.find(f => f.name == inputText)
        const _choosenFriends = { ...choosenFriends, [permissionMask]: choosenFriends[permissionMask].concat({ ...currentFriend, permissionMask, targetObjectType: "User" }) }
        setChoosenFriends(_choosenFriends);
        setFriendsList(friendsList.filter(f => f.targetObjectId !== currentFriend.targetObjectId))
        setInputText("");
        setPermissionMask("RunnerOnly");
        if (beenSharedBefore) {
            changeSpecificFriends(_choosenFriends);
        }
    }

    useClickOutside(AutoCompleteRef, () => {
        setShowParticipants(false)
    });

    return (
        <div className={classes.AutoComplete}>
            <div className={classes.AutoCompleteContainer} ref={AutoCompleteRef}>
                <input className={classes.Input} value={inputText} onChange={(e) => showFriends(e.target.value)} placeholder={texts.specificFriendsAutoCompletePlaceholder} />
                <select className={classes.SelectContainer} value={permissionMask} onChange={(e) => setPermissionMask(e.target.value)}>
                    {Object.keys(PermmisionPostsTypeEnum).map(s => <option key={s} className={classes.Option} value={s}>{texts[s]}</option>)}
                </select>
                {showParticipants && friendsList && <div className={classes.AllNames}>
                    {friendsList.map((f, index) => {
                        return f.name.includes(inputText) &&
                            <div key={f.targetObjectId}>
                                <p className={classes.Name} onClick={() => chooseFriend(f)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => chooseFriend(f))}>{f.name}</p>
                                {index !== friendsList.length - 1 && <hr className={classes.Hr} />}
                            </div>
                    })}
                </div>}
            </div>
            {friendsList && <button className={`${classes.AddBtn} ${friendsList.find(f => f.name == inputText) ? classes.ActiveBtn : ''}`} disabled={!friendsList.find(f => f.name == inputText)} onClick={addFriend}>{texts.add}</button>}
        </div>
    )
}
export default AutoComplete;